"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppBar = void 0;
/* eslint-disable react/jsx-no-bind */
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const DefaultBar_1 = require("./components/DefaultBar");
const MobileBar_1 = require("./components/MobileBar");
const react_router_dom_1 = require("react-router-dom");
const hooks_1 = require("../../hooks");
const drawerWidth = 240;
// eslint-disable-next-line @rushstack/typedef-var
const useStyles = styles_1.makeStyles((theme) => styles_1.createStyles({
    root: {
        display: 'flex'
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        boxShadow: theme.shadows[0],
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        userSelect: 'none'
    },
    menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            display: 'none'
        }
    },
    toolbar: {
        minHeight: 76
    },
    drawerPaper: {
        width: drawerWidth
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(2),
        top: 77,
        left: drawerWidth,
        right: 0,
        bottom: 0,
        position: 'fixed',
        overflowY: 'auto'
    },
    contentMobile: {
        flexGrow: 1,
        padding: theme.spacing(0.5),
        top: 77,
        left: 0,
        right: 0,
        bottom: 0,
        position: 'fixed',
        overflowY: 'auto'
    },
    appLogo: {
        color: theme.palette.primary.main,
        textTransform: 'none',
        fontSize: '1.1rem'
    }
}));
const AppBar = (p) => {
    const props = Object.assign(Object.assign({}, p), { searchBarPlaceholder: p.searchBarPlaceholder || 'Search anything...', appIsLoading: p.appIsLoading || false, userHeadings: p.userHeadings || ['Your Profile'], appName: p.appName || 'Enterprise Hub' });
    const classes = useStyles();
    const menuLeft = hooks_1.useComponentVisibility('menuLeft');
    const menuUser = hooks_1.useComponentVisibility('menuUser');
    const [anchorEl, setAnchorEl] = react_1.useState(null);
    const setMenuUserVisible = (event) => {
        setAnchorEl(event.currentTarget);
        menuUser.setVisible();
    };
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(core_1.Hidden, { smDown: true },
            react_1.default.createElement(DefaultBar_1.DefaultBar, Object.assign({}, props, { setMenuUserVisible: setMenuUserVisible }))),
        react_1.default.createElement(core_1.Hidden, { mdUp: true },
            react_1.default.createElement(MobileBar_1.MobileBar, Object.assign({}, props, { setMenuUserVisible: setMenuUserVisible }))),
        react_1.default.createElement(core_1.Popover, { id: "userMenuPopover", anchorEl: anchorEl, open: menuUser.isVisible, onClose: menuUser.setHidden, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center'
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'center'
            } }, props.componentMenuUser),
        props.componentMenuLeft && (react_1.default.createElement("div", null,
            react_1.default.createElement(core_1.Hidden, { mdUp: true },
                react_1.default.createElement(core_1.Drawer, { variant: "temporary", open: menuLeft.isVisible, onClose: menuLeft.setHidden, ModalProps: { keepMounted: true }, classes: { paper: classes.drawerPaper } },
                    react_1.default.createElement(core_1.Button, { to: "/", component: react_router_dom_1.Link, style: { padding: 15, margin: 15 } }, props.componentLogo ? (props.componentLogo) : (react_1.default.createElement("span", { className: classes.appLogo }, props.appName))),
                    props.componentMenuLeft)),
            react_1.default.createElement(core_1.Hidden, { smDown: true },
                react_1.default.createElement("nav", { className: classes.drawer },
                    react_1.default.createElement(core_1.Drawer, { className: classes.drawer, variant: "permanent", classes: { paper: classes.drawerPaper } },
                        react_1.default.createElement("div", { className: classes.toolbar }),
                        props.componentMenuLeft))))),
        props.children && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.Hidden, { mdUp: true },
                react_1.default.createElement("div", { className: classes.contentMobile }, props.children)),
            react_1.default.createElement(core_1.Hidden, { smDown: true },
                react_1.default.createElement("div", { className: classes.content }, props.children))))));
};
exports.AppBar = AppBar;
//# sourceMappingURL=index.js.map